module.exports = __webpack_public_path__ + "img/pleasure-icon-8.72ba6db0.svg";